
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import slider1 from "../asset/images/revamp-images/slider1Img.svg";
import slider2 from "../asset/images/revamp-images/slider2Img.svg";
import slider3 from "../asset/images/revamp-images/slider3Img.svg";
import Slider from "react-slick";
import revenueImg from "../asset/images/revamp-images/revenueSharing.svg";
import supportImg from "../asset/images/revamp-images/support.svg";
import earningDashImg from "../asset/images/revamp-images/liveEarning.svg";
import legacyImg from "../asset/images/revamp-images/legacy.svg";
import marginTrading from "../asset/images/revamp-images/marginTradingFacility.svg";
import brokerage from "../asset/images/revamp-images/brokerage.svg";
import subscription from "../asset/images/revamp-images/subscriptionPlan.svg";
import marginLabel from "../asset/images/revamp-images/marginLabel.svg";
import brokerageLabel from "../asset/images/revamp-images/brokerageLabel.svg";
import subscriptionLabel from "../asset/images/revamp-images/subscriptionLabel.svg";
import professional from "../asset/images/revamp-images/professionalIcon.svg";
import students from "../asset/images/revamp-images/studentsImg.svg";
import stockTutor from "../asset/images/revamp-images/stockTutorImg.svg";
import housingMember from "../asset/images/revamp-images/housingMemberImg.svg";
import influencer from "../asset/images/revamp-images/InfluencerImg.svg";
import textList from "../asset/images/revamp-images/textList1.svg";
import textList2 from "../asset/images/revamp-images/textList2.svg";
import textList3 from "../asset/images/revamp-images/textList3.svg";
import emailIcon from "../asset/images/revamp-images/emailIcon.svg";
import callIcon from "../asset/images/revamp-images/callIcon.svg";
import {Link} from "react-router-dom";


const PageSideBar= ()=>{
    

    var settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 5000,
        autoplaySpeed: 5000,
        arrows: false,
        // cssEase: "linear"
      };
    return(
       
              <div className="page-header left-box">
                <div className="signinpage-slider">
                  <Slider {...settings}>
                    {/* <div> */}
                    <div>
                      <div className="slider-img-wrapper">
                        <img src={slider1} className="slider-img" />
                        <label className="slider-text">
                          Achieve your earning potential
                        </label>
                      </div>
                    </div>

                    <div>
                      <div className="slider-img-wrapper">
                        <img src={slider2} className="slider-img" />
                        <label className="slider-text">
                          Detailed Dashboard for tracking
                        </label>
                      </div>
                    </div>

                    <div>
                      <div className="slider-img-wrapper">
                        <img src={slider3} className="slider-img" />
                        <label className="slider-text">
                          Active support to boost your revenue
                        </label>
                      </div>
                    </div>

                    {/* </div> */}
                  </Slider>

                  <div className="signinpage-slider product-text">
                    <label className="product-content">
                      Products offering a consistent stream of income
                    </label>
                    <div className="content-wrapper-main">
                      <div className="contentImg-wrapper">
                        <img src={revenueImg} className="content-img" />
                        <label className="content-text">
                          High Revenue Sharing
                        </label>
                      </div>
                      <div className="contentImg-wrapper">
                        <img src={supportImg} className="content-img" />
                        <label className="content-text">
                          Instant Support Team
                        </label>
                      </div>
                      <div className="contentImg-wrapper">
                        <img src={earningDashImg} className="content-img" />
                        <label className="content-text">
                          Live Earning Dashboard
                        </label>
                      </div>
                      <div className="contentImg-wrapper">
                        <img src={legacyImg} className="content-img" />
                        <label className="content-text">
                          Legacy and <br/>Trust of ‘Bajaj’
                        </label>
                      </div>
                    </div>

                    <label className="product-content">
                      Earn commissions across investment products
                    </label>
                    <div className="content-wrapper-main comission-wrapper">
                      <div className="contentImg-wrapper investment-wrap">
                        <img
                          src={marginTrading}
                          className="content-img investment-images"
                        />
                        <img src={marginLabel} className="label-img" />
                      </div>
                      <div className="contentImg-wrapper investment-wrap">
                        <img
                          src={brokerage}
                          className="content-img investment-images"
                        />
                        <img src={brokerageLabel} className="label-img" />
                      </div>
                      <div className="contentImg-wrapper investment-wrap">
                        <img
                          src={subscription}
                          className="content-img investment-images"
                        />
                        <img src={subscriptionLabel} className="label-img" />
                      </div>
                    </div>

                    <div  className="become-partner-main">
                        <div className="become-partner">
                            <div className="become-partner-text-wrapper">
                        <div className="become-partner-text">
                            WHO CAN BECOME A PARTNER?
                            </div>
                            </div>
                            <ul className="become-partner-cards">
                                <li>
                                    <div className="become-partner-list">
                                        <img src={professional} href="professional_img"/>
                                        <p>
                                        Working Professionals
                                        </p>
                                    </div>

                                </li>
                                <li>
                                    <div className="become-partner-list">
                                        <img src={students} href="students_img"/>
                                        <p>
                                        Students
                                        </p>
                                    </div>

                                </li>
                                <li>
                                    <div className="become-partner-list">
                                        <img src={housingMember} href="housing_member"/>
                                        <p>
                                        Housing Society Members
                                        </p>
                                    </div>

                                </li>
                                
                                <li>
                                    <div className="become-partner-list">
                                        <img src={stockTutor} href="stock_tutor"/>
                                        <p>
                                        Stock Market Tutors
                                        </p>
                                    </div>

                                </li>
                                
                                <li>
                                    <div className="become-partner-list">
                                        <img src={influencer} href="influencer"/>
                                        <p>
                                        Influencers
                                        </p>
                                    </div>

                                </li>
                                

                            </ul>
                        </div>
                    </div>

                    <div className="bajaj-partner">
                        <p>
                        How to become a Bajaj Broking partner
                        </p>
                    </div>

                    <div className="bajaj-partner-content-wrap">
                        <div className="bajaj-partner-content">
                            <img src={textList} href="textList"/>
                            <p>Sign-up online by completing our form above or leave your details and our Partnership team will get in touch with you</p>
                        </div>
                        <div className="bajaj-partner-content">
                        <img src={textList2} href="textList2"/>
                            <p>Share your basic details like name, PAN, email, and mobile number</p>
                        </div>
                        <div className="bajaj-partner-content">
                        <img src={textList3} href="textList3"/>
                            <p>Once approved, you can start referring and earning commission when your client starts investing</p>
                        </div>
                    </div>

                    <div className="contact-support">
                        <p>Need help? Contact our <p className="support-text"> Customer Support</p></p>
                        
                            <ul className="email-content-wrap">
                                <li>

                                <div className="email-content">
                            <img src={emailIcon} href="email_icon" />
                            <p className="text-bold">Email Us:</p>
                           <a href="mailto:partner@bajajbroking.in">
                            <span>partner@bajajbroking.in</span>
                            </a>
                        </div>
                        </li>
                        <li>
                        <div className="email-content">
                            <img src={callIcon} href="call_icon" />
                            <p className="text-bold">Call Us:</p>
                            <a href="tel:9920996257">
                            <span>9920996257</span>
                            </a>
                            &nbsp;<p>/</p>&nbsp; 
                            <a href="tel:7028882457">
                            <span>7028882457</span>
                            </a>
                        </div>
                                </li>
                            </ul>
                       
                        
                    </div>
                  </div>
                </div>
              </div>
            
    )
};

export default PageSideBar;